import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { TransactionResponseDto } from "../dto/response/transaction-response-dto";

@Injectable({
  providedIn: "root"})
export class TransactionService {
  constructor(private _httpClient: HttpClient) {}

  getTransactionsByWalletId(
    walletId: string,
    page: number,
    pageSize: number,
    originType?: string
  ): Observable<TransactionResponseDto> {
    return this._httpClient.get<TransactionResponseDto>(
      `${environment.backend}/wallet-transactions?walletId=${walletId}&page=${page}&pageSize=${pageSize}&originType=${originType}`
    );
  }
}
